/* eslint-disable no-new */
import Vue from 'vue/dist/vue.esm';

const videos = document.querySelectorAll('[data-component="video"]');
[...videos].forEach(el => {
  new Vue({
    el,
    computed: {
      videoWrapperClasses() {
        return {
          'is-playing': this.isVideoPlaying,
          'is-paused': !this.isVideoPlaying,
        };
      },
    },
    data() {
      return {
        isVideoPlaying: false,
      };
    },
  });
});
